import { all, put, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import {
  FETCH_ALL_BOOKINGS_REQUEST,
  FETCH_ALL_BOOKINGS_SUCCESS,
  FETCH_ALL_BOOKINGS_FAILURE,
  CREATE_BOOKING_REQUEST,
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_FAILURE,
  EDIT_BOOKING_REQUEST,
  EDIT_BOOKING_SUCCESS,
  EDIT_BOOKING_FAILURE,
  DELETE_BOOKING_REQUEST,
  DELETE_BOOKING_SUCCESS,
  DELETE_BOOKING_FAILURE,
  SET_LOADING_STATE,
  RESET_LOADING_STATE,
} from "../constants";
import {
  firebaseFetchAllBookings,
  firebaseCreateBooking,
  firebaseEditBooking,
  firebaseDeleteBooking,
} from "../api/booking";

function* fetchAllBookingsFn({ payload }: any): any {
  try {
    const response = yield firebaseFetchAllBookings(payload);
    if (response) {
      yield put({
        type: FETCH_ALL_BOOKINGS_SUCCESS,
        payload: { allBookings: response },
      });
    } else {
      yield put({ type: FETCH_ALL_BOOKINGS_FAILURE });
    }
  } catch (err) {
    yield put({ type: FETCH_ALL_BOOKINGS_FAILURE });
  }
}

function* createBookingFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE })
    const response = yield firebaseCreateBooking(payload);
    if (response) {
      yield put({
        type: CREATE_BOOKING_SUCCESS,
        payload: { newBooking: response },
      });
    } else {
      yield put({ type: CREATE_BOOKING_FAILURE });
    }
    yield put({ type: RESET_LOADING_STATE });
  } catch (err) {
    yield put({ type: CREATE_BOOKING_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* editBookingFn({ payload }: any): any {
  try {
    const response = yield firebaseEditBooking(payload);
    if (response) {
      yield put({
        type: EDIT_BOOKING_SUCCESS,
        payload: { allBookings: response },
      });
    } else {
      yield put({ type: EDIT_BOOKING_FAILURE });
    }
  } catch (err) {
    yield put({ type: EDIT_BOOKING_FAILURE });
  }
}

function* deleteBookingFn({ payload }: any): any {
  try {
    const response = yield firebaseDeleteBooking(payload);
    if (response) {
      yield put({
        type: DELETE_BOOKING_SUCCESS,
        payload: { allBookings: response },
      });
    } else {
      yield put({ type: DELETE_BOOKING_FAILURE });
    }
  } catch (err) {
    yield put({ type: DELETE_BOOKING_FAILURE });
  }
}

export default function* bookingSaga(): SagaIterator {
  yield all([
    takeEvery(FETCH_ALL_BOOKINGS_REQUEST, fetchAllBookingsFn),
    takeEvery(CREATE_BOOKING_REQUEST, createBookingFn),
    takeEvery(EDIT_BOOKING_REQUEST, editBookingFn),
    takeEvery(DELETE_BOOKING_REQUEST, deleteBookingFn),
  ]);
}
